
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
  import FieldTitle from '@/components/forms/fields/FieldTitle.vue'
  import dayjs from 'dayjs'

@Component({
  components: { FieldTitle },
})
  export default class GTimeSelector extends Vue {
  @Prop({ type: Object, default: () => ({ start: '', end: '' }) }) value!: { start: string, end: string };
  @Prop({ type: Object, default: undefined }) limits: { start: string, end: string };
  @Prop({ type: String, default: '' }) title!: string;
  @Prop({ type: Boolean, default: false }) required!: boolean;
  @Prop({ type: Number, default: 6 }) min
  @Prop({ type: Number, default: 23 }) max
  @Prop({ type: Number, default: 30 }) granularity

  start: string = '';
  end: string = '';
  masked: boolean = false;

  get timeMask () {
    return {
      mask: '##:##',
      kind: this.masked ? 'external' : 'both',
      eager: false,
      reversed: false,
      tokensReplace: false,
    }
  }

  @Watch('start')
  removeEnd (newStart) {
    if (!newStart) {
      this.end = ''
    }
  }

  @Watch('start')
  @Watch('end')
  onTimeChange () {
    if (this.isValidTime(this.start) && this.isValidTime(this.end)) {
      this.emitTime()
    }
  }

  @Watch('value', { immediate: true })
  onValueChange () {
    this.start = this.value.start
    this.end = this.value.end
  }

  validateStart (): string | boolean {
    if (!this.start) return 'El campo es obligatorio'

    if (!this.isValidTime(this.start)) return 'Tiempo inicio inválido'
    if (
      this.limits &&
      dayjs(`2025-01-01T${this.start}`)
        .isBefore(dayjs(`2025-01-01T${this.limits.start}`))
      ) {
      return 'Debe estar sujeto al horario de la empresa'
    }

    return true
  }

  validateEnd (): string | boolean {
    if (!this.end) return 'El campo es obligatorio'

    if (!this.isValidTime(this.end)) return 'Tiempo fin inválido'
    if (
      this.limits &&
      dayjs(`2025-01-01T${this.end}`)
        .isAfter(dayjs(`2025-01-01T${this.limits.end}`))
      ) {
      return 'Debe estar sujeto al horario de la empresa'
    }
    if (
      dayjs(`2025-01-01T${this.end}`)
        .isBefore(dayjs(`2025-01-01T${this.start}`))
      ) {
      return 'La hora de fin no puede ser antes que la hora de inicio'
    }
    if (
      dayjs(`2025-01-01T${this.end}`)
        .isSame(dayjs(`2025-01-01T${this.start}`))
      ) {
      return 'La hora de fin no puede ser igual a la hora de inicio'
    }

    return true
  }

  isValidTime (time: string): boolean {
    const timePattern = /^([01]\d|2[0-3]):([0-5]\d)$/
    return timePattern.test(time)
  }

  emitTime () {
    this.$emit('input', { start: this.start, end: this.end })
  }

  get timeItems () {
    const { min, max, granularity } = this
    const items = []
    for (let i = min; i <= max; i++) {
      const formattedHour = i < 10 ? `0${i}` : i
      for (let j = 0; j < 60; j += granularity) {
        const formattedMinute = j < 10 ? `0${j}` : j
        items.push(`${formattedHour}:${formattedMinute}`)
      }
    }
    return items
  }
  }
